/**
 * The mark: a ramp descending to the right with three slats across it — the
 * shape of an actual slipway. Geometric, reads at 16px, and unlike a generic
 * arrow it says "the place where things cross over" rather than "download".
 */
export function Mark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      {/* Two elements only: the ramp, and the waterline it runs into. Anything
          more turned to mush at 16px. This is literally a slipway in profile. */}
      <path d="M3 18.5 H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.45" />
      <path d="M5.5 4.5 L18 18.5" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  );
}

const s = { width: 16, height: 16, fill: 'none', 'aria-hidden': true } as const;

export const IconSettings = () => (
  <svg {...s} viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M12 2v3M12 19v3M22 12h-3M5 12H2M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1M18.4 18.4l-2.1-2.1M7.7 7.7L5.6 5.6"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const IconDevices = () => (
  <svg {...s} viewBox="0 0 24 24">
    <rect x="2" y="4" width="13" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
    <rect x="16" y="9" width="6" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
    <path d="M6 18h5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconFolder = () => (
  <svg {...s} viewBox="0 0 24 24">
    <path
      d="M3 7a2 2 0 0 1 2-2h3.5l2 2.5H19a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);
